import React from 'react';
import { ArrowRight } from 'lucide-react';
export const SolutionSection = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 relative z-10" data-id="element-212">
      <div className="max-w-3xl mx-auto text-center" data-id="element-213">
        <h2 className="font-cormorant text-4xl md:text-5xl text-text-primary mb-4" data-id="element-214">
          El problema{' '}
          <span className="text-gold-light italic" data-id="element-215">no sos vos.</span>
        </h2>
        <p className="text-2xl text-gold-primary font-outfit mb-12" data-id="element-216">
          Es que nadie te dio un punto de partida claro.
        </p>

        <div className="surface-gradient border border-gold-dark/30 rounded-xl p-8 md:p-12 text-left shadow-2xl relative overflow-hidden" data-id="element-217">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-primary/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" data-id="element-218"></div>

          <p className="text-xl text-text-primary mb-8 leading-relaxed" data-id="element-219">
            Empezar tu camino espiritual no debería requerir años de
            investigación. Lo que necesitás no es más información. Es una guía
            clara que te tome de la mano y te diga:{' '}
            <span className="text-gold-light italic" data-id="element-220">"Empezá por acá."</span>
          </p>

          <div className="space-y-6" data-id="element-221">
            <div className="flex items-start gap-4" data-id="element-222">
              <ArrowRight className="w-6 h-6 text-gold-primary shrink-0 mt-1" data-id="element-223" />
              <p className="text-lg text-text-soft" data-id="element-224">
                Cuando tenés estructura, dejás de dar vueltas y empezás a
                practicar.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-225">
              <ArrowRight className="w-6 h-6 text-gold-primary shrink-0 mt-1" data-id="element-226" />
              <p className="text-lg text-text-soft" data-id="element-227">
                Cuando el material está adaptado a tu realidad, todo se siente
                más natural y propio.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-228">
              <ArrowRight className="w-6 h-6 text-gold-primary shrink-0 mt-1" data-id="element-229" />
              <p className="text-lg text-text-soft" data-id="element-230">
                Y cuando dejás de sentir que lo hacés mal, la magia empieza a
                fluir de verdad.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-231">
          <button onClick={scrollToPricing} className="btn-gold px-8 py-4 rounded-full text-lg font-bold uppercase tracking-wide shadow-lg" data-id="element-232">
            ESTOY LISTA PARA EMPEZAR
          </button>
        </div>
      </div>
    </section>;
};